export const formatPhoneNumber = (digits: string): string => {
  if (!digits) return "";
  const num = removeNonNumeric(digits);
  
  // Handle international numbers (11+ digits) or numbers with extensions
  if (num.length > 10) {
    // If it starts with 1 (US country code), format as US number with country code
    if (num.startsWith('1') && num.length === 11) {
      const countryCode = num.slice(0, 1);
      const areaCode = num.slice(1, 4);
      const prefix = num.slice(4, 7);
      const lineNumber = num.slice(7, 11);
      return `+${countryCode} (${areaCode}) ${prefix}-${lineNumber}`;
    }
    // For other international numbers or numbers with extensions, return with basic formatting
    return num.startsWith('1') ? `+${num}` : `+${num}`;
  }
  
  // Standard US phone number formatting (10 digits or less)
  const areaCode = num.slice(0, 3);
  const prefix = num.slice(3, 6);
  const lineNumber = num.slice(6, 10);

  if (num.length <= 3) return `(${areaCode}`;
  if (num.length <= 6) return `(${areaCode}) ${prefix}`;
  return `(${areaCode}) ${prefix}-${lineNumber}`;
};

export const removeNonNumeric = (value: string): string =>
  value.replace(/\D/g, "");
